'use client';

import { useParams } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';

import { LanguageItem, LanguageSelect as LanguageSelectBase } from '@hrworks/sui-core/LanguageSelect';

import { type Locale, routing, usePathname, useRouter } from '../../i18n/routing';

export const LanguageSelect = () => {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const locale = useLocale() as Locale;
  const t = useTranslations('Languages');

  const onLanguageChange = (newLocale: string) => {
    const searchParams = typeof window === 'undefined' ? '' : window.location.search;
    router.replace(
      // @ts-expect-error -- TypeScript will validate that only known `params`
      // are used in combination with a given `pathname`. Since the two will
      // always match for the current route, we can skip runtime checks.
      { pathname: `${pathname}${searchParams}`, params },
      { locale: newLocale as Locale },
    );
  };

  const sortedLocales = [...routing.locales].sort((a, b) => t(a).localeCompare(t(b), locale));

  return (
    <LanguageSelectBase
      language={locale}
      onLanguageChange={onLanguageChange}
      flagUrlBase="/flags"
      css={{ img: { border: 'none !important' } }}
      slotProps={{
        trigger: { variant: 'unstyled', 'data-guide-id': 'header-language-select', style: { color: 'inherit' } },
      }}
    >
      {sortedLocales.map((_locale) => (
        <LanguageItem data-guide-id={`header-language-select-option-${_locale}`} key={_locale} language={_locale}>
          {t(_locale)}
        </LanguageItem>
      ))}
    </LanguageSelectBase>
  );
};
